import type { FC } from "react";
import type { ContentFileDto } from "shared";
import { Icon } from "../../common/Icon";
import { PreviewAvatar } from "../shared/PreviewAvatar";
import { PreviewMedia } from "../shared/PreviewMedia";
import "./ThreadsPreview.css";

interface ThreadsPreviewProps {
	companyName: string;
	content: string;
	files: ContentFileDto[];
}

export const ThreadsPreview: FC<ThreadsPreviewProps> = ({
	companyName,
	content,
	files,
}) => {
	const username = companyName.toLowerCase().replace(/\s+/g, "");

	return (
		<div className="th-preview">
			<div className="th-preview__left">
				<div className="th-preview__avatar-wrapper">
					<PreviewAvatar name={companyName} size="sm" />
				</div>
				<div className="th-preview__line" />
			</div>

			<div className="th-preview__main">
				<div className="th-preview__header">
					<span className="th-preview__username">{username}</span>
					<span className="th-preview__time">2h</span>
				</div>

				<div className="th-preview__content">
					<p className="th-preview__text">{content}</p>
				</div>

				{files.length > 0 && (
					<div className="th-preview__media">
						<PreviewMedia files={files} aspectRatio="auto" />
					</div>
				)}

				<div className="th-preview__actions">
					<button type="button" className="th-preview__action">
						<Icon name="favorite" size={20} />
					</button>
					<button type="button" className="th-preview__action">
						<Icon name="chat_bubble" size={20} />
					</button>
					<button type="button" className="th-preview__action">
						<Icon name="repeat" size={20} />
					</button>
					<button type="button" className="th-preview__action">
						<Icon name="send" size={20} />
					</button>
				</div>

				<div className="th-preview__stats">
					<span>12 replies</span>
					<span>·</span>
					<span>34 likes</span>
				</div>
			</div>
		</div>
	);
};
